class Sport {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var swiper = new Swiper('.c-swiper-support', {
      speed: 2000,
      spaceBetween: 10,
      slidesPerView: 1,
      loop: true,
      breakpoints: {
        768: {
          spaceBetween: 16,
          slidesPerView: 3,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
      navigation: {
        nextEl: '.s-support-next',
        prevEl: '.s-support-prev',
      },
    })
  }
}
